import { ThemeProviderProps } from '@servicetitan/anvil2';
import { themeLight as themeLightUi } from '@servicetitan/web-feature-ui';

export const themeLight: NonNullable<ThemeProviderProps['theme']> = {
    ...themeLightUi,
    component: {
        ButtonPrimaryForegroundColorActive: { value: '#D9D9D9' },
        ButtonPrimaryBackgroundColor: { value: '#141414' },
        ButtonPrimaryBackgroundColorHover: { value: '#3A3A3A' },
        ButtonPrimaryBackgroundColorActive: { value: '#141414' },
        CheckboxCheckedFillColor: { value: '#141414' },
        CheckboxCheckedFillColorHover: { value: '#141414' },
        CheckboxCheckedFillColorActive: { value: '#141414' },
        // @ts-expect-error anvil has not yet exported the type for this prop
        CheckboxCheckedFillColorDefault: { value: '#141414' },
    },
};
